import { render } from "./DefaultSvgPlus.vue?vue&type=template&id=5039a686&scoped=true"
import script from "./DefaultSvgPlus.vue?vue&type=script&lang=js"
export * from "./DefaultSvgPlus.vue?vue&type=script&lang=js"

import "./DefaultSvgPlus.vue?vue&type=style&index=0&id=5039a686&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5039a686"]])

export default __exports__